import React from 'react';

const Steps: React.FC = () => {
  return (
    <div className="flex justify-center px-4 py-4"> 
      <div className='w-full max-w-screen-lg mx-auto overflow-hidden'> 
        <img src="/img/steps.png" className="w-full h-auto" alt="" />
      </div>
    </div>
  );
};

export default Steps;
